import { render, staticRenderFns } from "./QuestionInputCheckboxList.vue?vue&type=template&id=4994a5e8&"
import script from "./QuestionInputCheckboxList.vue?vue&type=script&lang=ts&"
export * from "./QuestionInputCheckboxList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports